import Flex from "@/shared/components/common/Flex";
import List from "@/shared/components/common/List";
import Typography from "@/shared/components/common/Typography";

interface HotelCardTagsProps {
  tags: string[];
}

export default function HotelCardTags({ tags }: HotelCardTagsProps) {
  return (
    <Flex alignItems={"center"} gap={"2"}>
      <List
        items={tags}
        renderItems={(tag) => (
          <Flex.Item className="bg-muted/10 ring-1 ring-border rounded-full px-3">
            <Typography variant={"caption"} className="text-muted-foreground">
              {tag}
            </Typography>
          </Flex.Item>
        )}
      />
    </Flex>
  );
}
